import { Injectable } from '@angular/core'

/**
 * Sanitizes a returnUrl so that it always contains a single internal route
 * and never points back to the login page (which would cause a redirect loop).
 * Nested/concatenated returnUrls are unwrapped to their deepest target.
 * Returns an empty string when the value is missing, external or invalid.
 */
export function sanitizeReturnUrl (rawUrl: string | string[] | null | undefined): string {
  if (Array.isArray(rawUrl)) {
    rawUrl = rawUrl[0]
  }

  if (!rawUrl) {
    return ''
  }

  let candidate = String(rawUrl).trim()
  let previous = ''
  let guard = 0

  while (candidate && candidate !== previous && guard++ < 10) {
    previous = candidate
    const parts = candidate.split(/returnUrl=/i)
    if (parts.length > 1) {
      candidate = parts[parts.length - 1].split('&')[0]
    }
    try {
      candidate = decodeURIComponent(candidate)
    } catch { /* keep the raw value when it is not decodable */ }
  }

  candidate = candidate.split('?')[0].split('#')[0]

  if (!candidate.startsWith('/') || /^\/login(\/|$)/i.test(candidate)) {
    return ''
  }

  return candidate
}

@Injectable({
  providedIn: 'root'
})
export class FuseqUtils {
  removeNullKeysFromObject (obj) {
    const newObj = {}
    Object.keys(obj).forEach(key => {
      if (obj[key] !== 'date' && obj[key] && typeof obj[key] === 'object') {
        newObj[key] = this.removeNullKeysFromObject(obj[key]) // recurse
      } else if (obj[key] !== null && obj[key] !== undefined) {
        newObj[key] = obj[key].toString() // copy value
      }
    })
    return newObj
  }

  checkArrays (arr1, arr2) {
    let isExist = false
    arr1.forEach((item: any) => {
      if (arr2) {
        if (arr2.indexOf(item) > -1) {
          isExist = true
        }
      }
    })
    return isExist
  }

  groupBy (data, key: string) {
    return data.reduce(function (storage, item) {
      const group = item[key]
      storage[group] = storage[group] || []
      storage[group].push(item)
      return storage
    }, {})
  }

  getDistinctArray (arr) {
    const dups = {}
    return arr.filter(function (el) {
      const hash = el.valueOf()
      const isDup = dups[hash]
      dups[hash] = true
      return !isDup
    })
  }

  removeDuplicatesfromObjectArray (originalArray, prop) {
    const newArray = []
    const lookupObject = {}
    for (const elem of Object.keys(originalArray)) {
      lookupObject[originalArray[elem][prop]] = originalArray[elem]
    }
    for (const elem of Object.keys(lookupObject)) {
      newArray.push(lookupObject[elem])
    }
    return newArray
  }

  deleteObj (obj) {
    for (const [key] of Object.entries(obj)) {
      delete obj[key]
    }
    return obj
  }

  resetObject (obj, boolDefault = false, stringDefault = '', numberDefault = 0) {
    for (const [key, value] of Object.entries(obj)) {
      const propType = typeof (obj[key])
      switch (propType) {
        case 'number' :
          obj[key] = numberDefault
          break
        case 'string':
          obj[key] = stringDefault
          break
        case 'boolean':
          obj[key] = boolDefault
          break
        case 'undefined':
          obj[key] = undefined
          break
        default:
          if (value === null) {
            continue
          }
          this.resetObject(obj[key])
          break
      }
    }
  }
}
/*
async pushToArray(data) {
  let arrayT = [];
  await data.forEach(l => {
    arrayT.push(l);
  });
  return arrayT;
}
async createArray(data) {
  let groupbytype = [];
  await data.forEach(l => {
    if (groupbytype[l.type]) {
      groupbytype[l.type][l.status] = l.count_status
    } else {
      groupbytype[l.type] = {};
      groupbytype[l.type].type = l.type;
      groupbytype[l.type].info = 0;
      groupbytype[l.type].success = 0;
      groupbytype[l.type].warning = 0;
      groupbytype[l.type].danger = 0;
      groupbytype[l.type][l.status] = l.count_status
    }
  });
  return groupbytype;
}
*/
/* let mergedArray = Array.from(data.reduce((entryMap, e) =>
          entryMap.set(e.type, { ...entryMap.get(e.type) || {}, ...e }),
          new Map()).values()); */
// let groupedStatus = data.reduce((entryMap, e) => entryMap.set(e.status, [...entryMap.get(e.status) || [], e]), new Map());
// let test = Array.from(groupedMap).reduce((entryMap, e) =>
// entryMap.set(e.type, { ...entryMap.get(e.type) || {}, ...e }), new Map());
